import { render, staticRenderFns } from "./ProfileSignupStep.vue?vue&type=template&id=3fbb4a71&"
import script from "./ProfileSignupStep.vue?vue&type=script&lang=ts&"
export * from "./ProfileSignupStep.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSignupStep.vue?vue&type=style&index=0&id=3fbb4a71&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fbb4a71')) {
      api.createRecord('3fbb4a71', component.options)
    } else {
      api.reload('3fbb4a71', component.options)
    }
    module.hot.accept("./ProfileSignupStep.vue?vue&type=template&id=3fbb4a71&", function () {
      api.rerender('3fbb4a71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/guest/gsx/signupSteps/ProfileSignupStep.vue"
export default component.exports